import {SimplePresentation, SimplePresentationRunnerController} from "../../SimplePresentationRunner";
import {gsap} from "gsap";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../../reels/symbols/BasicSymbol";
import {SimpleReelModelSymbolData} from "../../../core/reel/simplereel/SimpleReelModel";
import {XWaySymbol} from "../../reels/symbols/XWaySymbol";
import {XSplitSymbol} from "../../reels/symbols/XSplitSymbol";
import {XwaysHoarder2Sound} from "../../sound/XwaysHoarder2Sound";


export class ReverseXWaysAndWildToSplitConversionPresentation implements SimplePresentation {
    name: string = "ReverseXWaysNWildToSplitConversionPresentation";
    private _rvstl: gsap.core.Timeline;

    shouldRun(): boolean {
        return (XwaysHoarder2.model.isBonusGameSpin || XwaysHoarder2.model.isRespinStarting) && !XwaysHoarder2.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        this._rvstl = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });



        if (XwaysHoarder2.model.gameData) {
            if (XwaysHoarder2.model.gameData.betWayWins.length > 0) {
                XwaysHoarder2.reelView.hideReelsNoWinOverlay();
            }
        }

        const startTime: number = XwaysHoarder2.model.gameData!.totalSpinWinnings > 0 ? 1 : 0.5;
        let closeSoundPlayed: boolean = false;
        let xsReverseSoundPlayed: boolean = false;
        [1, 2, 3, 4, 5].forEach((reeId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                const currentSymData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reeId].model.getVisibleSymbolAt(symId);


                if (currentSymData.name === "XW") {//part one - reverse Xways reveal and scale animation
                    const xwTL: gsap.core.Timeline = gsap.timeline();
                    const xwSym: XWaySymbol = <XWaySymbol>currentSymData.positionable;
                    xwTL.add(xwSym.getStateAnimation(SymbolStates.REVERT));
                    if(!closeSoundPlayed) {
                        xwTL.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XWAY_CLOSE);
                        }, "<");
                        closeSoundPlayed = true;
                    }

                    this._rvstl.add(xwTL, startTime);
                }


                if (currentSymData.name === "XS") {//part two - convert wild to xsplit
                    const wtxsTL: gsap.core.Timeline = gsap.timeline();
                    const xsSym: XSplitSymbol = <XSplitSymbol>currentSymData.positionable;
                    wtxsTL.add(xsSym.getStateAnimation(SymbolStates.REVERT));
                    if(!xsReverseSoundPlayed) {
                        wtxsTL.add(() => {
                            XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.XSPLIT_RESPIN_TO_WILD);
                        }, "<");
                        xsReverseSoundPlayed = true;
                    }
                    this._rvstl.add(wtxsTL, startTime);
                }
            });
        });

        this._rvstl.addLabel("scaleCheckNow");

        [1, 2, 3, 4, 5].forEach((reelId: number) => {
            [0, 1, 2].forEach((symId: number) => {
                const symData: SimpleReelModelSymbolData = XwaysHoarder2.reelView.reels[reelId].model.getVisibleSymbolAt(symId);
                const symToScaleDown: BasicSymbol = <BasicSymbol>symData.positionable;
                if ((symToScaleDown.visualHeightStatus !== symToScaleDown.symbolHeight * 200) || symToScaleDown.isScaled) {
                    const rvrseScaleTl: gsap.core.Timeline = gsap.timeline();
                    rvrseScaleTl.add(symToScaleDown.getStateAnimation(SymbolStates.REVERSE_SCALED));
                    this._rvstl.add(rvrseScaleTl, "scaleCheckNow");
                }
            });
        });


        controller.setSkipCallback(() => this.onPrsntationSkip());

    }

    private onPrsntationSkip(): void {
        if (XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.XSPLIT_RESPIN_TO_WILD)?.isPlaying) {
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.XSPLIT_RESPIN_TO_WILD);
        }
        if (XwaysHoarder2Sound.soundPlayer.fetchSoundPlayer(XwaysHoarder2Sound.XWAY_CLOSE)?.isPlaying) {
            XwaysHoarder2Sound.stopSound(XwaysHoarder2Sound.XWAY_CLOSE);
        }
        this._rvstl.totalProgress(1);
    }
}